import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NotfoundComponent } from './errors/notfound.component';
import { environment } from './../environments/environment';
import { AuthGuard } from './shared/auth/auth-guard.service';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), data: {
          animation: 'HomeModule',
          id: -979,
          name: '',
          title: $localize `:@@homepage:Strona główna`,
          content: '',
          description: '',
          keywords: '',
          canonical: environment.base,
          hideBredcrumbs: true
        }
      },
      {
        path: 'en', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), data: {
          animation: 'HomeModule',
          id: -979,
          name: '',
          title: $localize `:@@homepage:Strona główna`,
          content: '',
          description: '',
          keywords: '',
          canonical: environment.base,
          hideBredcrumbs: true
        }
      },
      {
        path: 'de', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), data: {
          animation: 'HomeModule',
          id: -979,
          name: '',
          title: $localize `:@@homepage:Strona główna`,
          content: '',
          description: '',
          keywords: '',
          canonical: environment.base,
          hideBredcrumbs: true
        }
      },
      {
        path: 'fr', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), data: {
          animation: 'HomeModule',
          id: -979,
          name: '',
          title: $localize `:@@homepage:Strona główna`,
          content: '',
          description: '',
          keywords: '',
          canonical: environment.base,
          hideBredcrumbs: true
        }
      },
      {
        path: 'es', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), data: {
          animation: 'HomeModule',
          id: -979,
          name: '',
          title: $localize `:@@homepage:Strona główna`,
          content: '',
          description: '',
          keywords: '',
          canonical: environment.base,
          hideBredcrumbs: true
        }
      },
      {
        path: 'it', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), data: {
          animation: 'HomeModule',
          id: -979,
          name: '',
          title: $localize `:@@homepage:Strona główna`,
          content: '',
          description: '',
          keywords: '',
          canonical: environment.base,
          hideBredcrumbs: true
        }
      },
      {path: $localize `:@@r_login:zaloguj`, loadChildren: () => import('./auth/login.module').then(m => m.LoginModule), data: {
        id: -980,
        name: $localize `:@@login:Zaloguj`,
        title: $localize `:@@login:Zaloguj`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base + '/' + $localize `:@@r_login:zaloguj`
      }},
      {path: $localize `:@@r_forgotpass:przypomnij-haslo`, loadChildren: () => import('./auth/password.module').then(m => m.PasswordModule), data: {
        id: -981,
        name: $localize `:@@forgotpass:Przypominj hasło`,
        title: $localize `:@@forgotpass:Przypominj hasło`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base + '/' + $localize `:@@r_forgotpass:przypomnij-haslo`
      }},
      {path: $localize `:@@r_register:rejestracja`, loadChildren: () => import('./auth/register.module').then(m => m.RegisterModule), data: {
        id: -982,
        name: $localize `:@@register:Rejestracja`,
        title: $localize `:@@register:Rejestracja`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base + '/' + $localize `:@@r_register:rejestracja`
      }},
      {path:  $localize `:@@r_register:rejestracja`+'/:type', loadChildren: () => import('./auth/register.module').then(m => m.RegisterModule), data: {
        id: -983,
        name: $localize `:@@register:Rejestracja`,
        title: $localize `:@@register:Rejestracja`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base + '/' + $localize `:@@r_register:rejestracja`+'/:type'
      }},
      {path: $localize `:@@r_logout:wyloguj`, loadChildren: () => import('./auth/logout.module').then(m => m.LogoutModule), data: {
        id: -984,
        name: $localize `:@@ulogout:Wyloguj`,
        title: $localize `:@@ulogout:Wyloguj`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_logout:wyloguj`
      }},
      {path: $localize `:@@r_account:konto`, loadChildren: () => import('./user/user.module').then(m => m.UserModule), canActivate: [AuthGuard], data: {
        id: -991,
        name: $localize `:@@uaccount:Konto`,
        title: $localize `:@@uaccount:Konto`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base + '/' + $localize `:@@r_account:konto`
      }},
      {path: $localize `:@@r_accountprofile:konto/profil`, loadChildren: () => import('./user/user-details.module').then(m => m.UserDetailsModule), canActivate: [AuthGuard], data: {
        id: -992,
        name: $localize `:@@uprofile:Dane adresowe`,
        title: $localize `:@@uprofile:Dane adresowe`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_accountprofile:konto/profil`
      }},
      {path: $localize `:@@r_accountpass:konto/haslo`, loadChildren: () => import('./user/user-password.module').then(m => m.UserPasswordModule), canActivate: [AuthGuard], data: {
        id: -1007,
        name: $localize `:@@upass:Zmiana hasła`,
        title: $localize `:@@upass:Zmiana hasła`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_accountpass:konto/haslo`
      }},
      {path: $localize `:@@r_ucontacts:konto/kontakty`, loadChildren: () => import('./user/user-contacts.module').then(m => m.UserContactsModule), canActivate: [AuthGuard], data: {
        id: -1011,
        name: $localize `:@@ucontacts:Kontakty`,
        title: $localize `:@@ucontacts:Kontakty`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base + '/' + $localize `:@@r_ucontacts:konto/kontakty`
      }},
      {path: $localize `:@@r_accountorders:konto/zamowienia`, loadChildren: () => import('./user/user-orders.module').then(m => m.UserOrdersModule), canActivate: [AuthGuard], data: {
        id: -993,
        name: $localize `:@@uorders:Zamówienia`,
        title: $localize `:@@uorders:Zamówienia`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_accountorders:konto/zamowienia`
      }},
      {path: $localize `:@@r_accountfvs:konto/faktury`, loadChildren: () => import('./user/user-documents.module').then(m => m.UserDocumentsModule), canActivate: [AuthGuard], data: {
        id: -1002,
        name: $localize `:@@ufvs:Faktury`,
        title: $localize `:@@ufvs:Faktury`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_accountfvs:konto/faktury`
      }},
      {path: $localize `:@@r_accountewd:konto/ewidencja`, loadChildren: () => import('./user/user-evidences.module').then(m => m.UserEvidencesModule), canActivate: [AuthGuard], data: {
        id: -1006,
        name: $localize `:@@uewd:Ewidencja montażu`,
        title: $localize `:@@uewd:Ewidencja montażu`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_accountewd:konto/ewidencja`
      }},
      {path: $localize `:@@r_accountbonuses:konto/bonusy`, loadChildren: () => import('./user/user-bonuses.module').then(m => m.UserBonusesModule), canActivate: [AuthGuard], data: {
        id: -1008,
        name: $localize `:@@ubonuses:Bonusy`,
        title: $localize `:@@ubonuses:Bonusy`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_accountbonuses:konto/bonusy`
      }},
      {path: $localize `:@@r_accountwarranties:konto/gwarancje`, loadChildren: () => import('./user/user-warranties.module').then(m => m.UserWarrantiesModule), canActivate: [AuthGuard], data: {
        id: -1009,
        name: $localize `:@@uwarranties:Gwarancje`,
        title: $localize `:@@uwarranties:Gwarancje`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_accountwarranties:konto/gwarancje`
      }},
      {path: $localize `:@@r_accountemploye:konto/pracownicy`, loadChildren: () => import('./user/user-users.module').then(m => m.UserUsersModule), canActivate: [AuthGuard], data: {
        id: -1003,
        name: $localize `:@@uemploye:Pracownicy`,
        title: $localize `:@@uemploye:Pracownicy`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_accountemploye:konto/pracownicy`
      }},
      {path: $localize `:@@r_files:konto/pliki`, loadChildren: () => import('./user/user-files.module').then(m => m.UserFilesModule), canActivate: [AuthGuard], data: {
        id: -1004,
        name: $localize `:@@ufiles:Pliki`,
        title: $localize `:@@ufiles:Pliki`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_files:konto/pliki`
      }},
      {path: $localize `:@@r_accountreturns:konto/zwroty`, loadChildren: () => import('./user/user-returns.module').then(m => m.UserReturnsModule), canActivate: [AuthGuard], data: {
        id: -994,
        name: $localize `:@@ucompl:Reklamacje`,
        title: $localize `:@@ucompl:Reklamacje`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_accountreturns:konto/zwroty`
      }},
      {path:  $localize `:@@r_discounts:konto/rabaty`, loadChildren: () => import('./user/user-discounts.module').then(m => m.UserDiscountsModule), canActivate: [AuthGuard], data: {
        id: -995,
        name: $localize `:@@udiscounts:Rabaty`,
        title: $localize `:@@udiscounts:Rabaty`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_discounts:konto/rabaty`
      }},
      {path: $localize `:@@r_clipboard:schowek`, loadChildren: () => import('./user/user-favorites.module').then(m => m.UserFavoritesModule), data: {
        id: -1005,
        name: $localize `:@@clipboard:Schowek`,
        title: $localize `:@@clipboard:Schowek`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_clipboard:schowek`
      }},
      {path: $localize `:@@r_checkout:kasa`, loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule), data: {
        id: -997,
        name: $localize `:@@checkout:Kasa`,
        title: $localize `:@@checkout:Kasa`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_checkout:kasa`
      }},
      {path: $localize `:@@r_pay:platnosc`, loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule), data: {
        id: -998,
        name: $localize `:@@payment:Płatność`,
        title: $localize `:@@payment:Płatność`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base +'/'+ $localize `:@@r_pay:platnosc`
      }},
      {path:  $localize `:@@r_thanks:dziekujemy`, loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule), data: {
        id: -999,
        name: $localize `:@@thxpay:Dziękujemy za płatność`,
        title: $localize `:@@thxpay:Dziękujemy za płatność`,
        content: '',
        description: '',
        keywords: ''
      }},
      {path:  $localize `:@@r_promo:promocje`+'/:path', loadChildren: () => import('./offer/offer.module').then(m => m.OfferModule), data: {
        id: -1000,
        name: $localize `:@@promoprod:Produkty w promocji`,
        title: $localize `:@@promoprod:Produkty w promocji`,
        content: '',
        description: '',
        keywords: 'produkty w promocji',
        canonical: environment.base + $localize `:@@r_promo:promocje`
      }},
      {path: 'order/:path/:token', loadChildren: () => import('./confirmations/confirmations.module').then(m => m.ConfirmationsModule), data: {
        id: -1001,
        name: $localize `:@@ordercnfrm:Potwierdzenie zamówienia`,
        title: $localize `:@@ordercnfrm:Potwierdzenie zamówienia`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base + '/order',
        hideBredcrumbs: true, 
      }},
      {path: 'evidence/:path/:token', loadChildren: () => import('./confirmations/confirmations.module').then(m => m.ConfirmationsModule), data: {
        id: -1001,
        name: $localize `:@@evdcnfrm:Potwierdzenie ewidencji`,
        title: $localize `:@@evdcnfrm:Potwierdzenie ewidencji`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base + '/evidence',
        hideBredcrumbs: true, 
      }},
      {path: 'product_register/:path/:token', loadChildren: () => import('./confirmations/confirmations.module').then(m => m.ConfirmationsModule), data: {
        id: -1010,
        name: $localize `:@@prdctregcnfrm:Potwierdzenie rejestracji produktu`,
        title: $localize `:@@prdctregcnfrm:Potwierdzenie rejestracji produktu`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base + '/product_register',
        hideBredcrumbs: true, 
      }},
      {path: 'reset/:path/:token', loadChildren: () => import('./confirmations/confirmations.module').then(m => m.ConfirmationsModule), data: {
        id: -1002,
        name: $localize `:@@resetpass:Resetowanie hasła`,
        title: $localize `:@@resetpass:Resetowanie hasła`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base + '/reset',
        hideBredcrumbs: true, 
      }},
      {path: 'dealer/:path', loadChildren: () => import('./distributors/distributor.module').then(m => m.DistributorModule), data: {
        id: -980,
        name: $localize `:@@dealer:Dealer`,
        title: $localize `:@@dealer:Dealer`,
        content: '',
        description: '',
        keywords: '',
        canonical: environment.base + '/' + $localize `:@@r_dealer:dealer`,
        hideBredcrumbs: true
      }},
      { path:  '404',  component: NotfoundComponent, data: { id: -905, title: '404', content: '', description: '', keywords: '' } },
      { path: '**', redirectTo: '/404', data: { id: -1, title: '', content: '', description: '', keywords: '' } }
    ], { initialNavigation: 'enabledNonBlocking', scrollPositionRestoration: 'enabled', enableTracing: false, anchorScrolling: 'enabled' })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
